var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #e8d5b2;\n      }\n\n      .st1 {\n        fill: #ffe9c7;\n      }\n\n      .st2 {\n        fill: #d1bd9d;\n      }\n\n      .st3 {\n        fill: #009432;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    y: 0,
    width: 512,
    height: 512,
    rx: 76.8,
    ry: 76.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M427.7,408.3H84.3c-16,0-29-13-29-29v-246.5c0-16,13-29,29-29h343.5c16,0,29,13,29,29v246.5c0,16-13,29-29,29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281.4,266.9l166.5-155c-5.2-5.1-12.3-8.2-20.2-8.2H84.3c-7.9,0-15,3.2-20.2,8.2l166.5,155c14.3,13.3,36.5,13.3,50.8,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M286.9,261.8l-5.5,5.1c-14.3,13.3-36.5,13.3-50.8,0l-5.5-5.1-160.6,138.5c5.2,4.9,12.1,7.9,19.8,7.9h343.5c7.7,0,14.6-3,19.8-7.9l-160.6-138.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIEmail);
export default __webpack_public_path__ + "static/media/i_email.491f8c32a9d1fcc5800b5d953b13abf2.svg";
export { ForwardRef as ReactComponent };